import { PAGE_TYPE, CLASSIFICATION_TYPE } from "../../constants";
import { eventPagePayloadCreator } from "../../helpers/eventPayloadCreator";
import { EventData, EventPayload } from "../../types";

export interface GameVoteClickedPayload extends EventPayload {
  game: {
    playTime: number;
  };
  content: {
    title: string;
  };
}

const GameVoteClickedAnalyticsEvent: EventData = {
  pageDetail: "",
  pageType: PAGE_TYPE.lowPoly,
  eventName: "Game Vote Clicked",
  classification: CLASSIFICATION_TYPE.experienceEvent,
};

export const createGameVoteClickedPageEventPayload =
  eventPagePayloadCreator<GameVoteClickedPayload>(
    GameVoteClickedAnalyticsEvent,
  );
